import React, { useEffect, useState } from 'react'
import { doctorPayRollPaymentHistoryAPI } from '../../Services/Operations/ProductAPI';
import { useSelector } from 'react-redux';
import Header from '../../Core/Header';
import { Section } from '../../Core/Section';

export const DoctorPaymentList = () => {
    const token = useSelector((state) => state.user.token);
    const [payments, setPayments] = useState([]);
    
    useEffect(() => {
        const doctorPayRollPayment = async () => {
          try {
            const response = await doctorPayRollPaymentHistoryAPI(token);
            console.log("doctorPayRollPaymentHistoryAPI : ", response);
            if (response.data) {
              setPayments(response.data);
            }
          } catch (error) {
            console.error("Error:", error);
          }
        };
    
        doctorPayRollPayment();
      }, [token]);

  return (
    <div id="main_content">
      <Header />
      <div className="page">
        <Section />
        <div className="section-body">
          <div className="container-fluid">
            <div className="d-flex justify-content-between align-items-center ">
              <div className="header-action">
                <h1 className="page-title">Doctor Payment History</h1>
                <ol className="breadcrumb page-breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="#">RNDSAN</a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Doctor Payments
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>

        <div className="section-body mt-4">
          <div className="container-fluid">
            <div className="tab-content">
              <div className="tab-pane active" id="Dep-all">
                <div className="table-responsive">
                 
                  <div className="table-responsive card">
                    <table className="table table-hover js-basic-example dataTable table-striped table_custom border-style spacing5">
                      <thead>
                        <tr>
                          <th>ID</th>
                          <th>Doctor ID</th>
                          <th>Doctor Name</th>
                          <th>Payment Date</th>
                          <th>Paid Amount</th>
                          <th>Due Amount</th>
                          <th>Payment Note</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {payments.map((payment) => (
                          <tr key={payment.id}>
                            <td>{payment.id}</td>
                            <td>{payment.doctorId}</td>
                            <td>{payment.doctorName}</td>
                            <td>{payment.paymentDate}</td>
                            <td>₹{payment.paidAmount}</td>
                            <td>₹{payment.dueAmount}</td>
                            <td>{payment.paymentNote || "N/A"}</td>
                            <td>
                              {payment.status === 1 ? (
                                <span className="badge badge-success">
                                  Completed
                                </span>
                              ) : (
                                <span className="badge badge-warning">
                                  Pending
                                </span>
                              )}
                            </td>
                            <td>
                              <button
                                type="button"
                                className="btn btn-icon btn-sm"
                                title="View"
                              >
                                <i className="fa fa-eye" />
                              </button>
                              <button
                                type="button"
                                className="btn btn-icon btn-sm"
                                title="Edit"
                              >
                                <i className="fa fa-edit" />
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="section-body">
          <footer className="footer">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-6 col-sm-12">
                  Copyright © 2025{" "}
                  <a href="">Technology support By - Siance Software Pvt Ltd</a>
                  .
                </div>
              </div>
            </div>
          </footer>
        </div>
      </div>
    </div>
  )
}